import { render, staticRenderFns } from "./MyFeedback.vue?vue&type=template&id=6ebdd97f&scoped=true"
import script from "./MyFeedback.vue?vue&type=script&lang=js"
export * from "./MyFeedback.vue?vue&type=script&lang=js"
import style0 from "./MyFeedback.vue?vue&type=style&index=0&id=6ebdd97f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebdd97f",
  null
  
)

export default component.exports